'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useEffect, useRef, useState } from 'react';
import {
    ILocationDropDown,
    ISmallArea,
    useSellCarNew,
    useTranslation,
} from '@/hook';
import { IRegion_SELL } from '@/types';
import {
    LocationFormContent,
    LocationMapForm,
} from '@/components/sell-car-form';
import styles from './styles.module.scss';
import { X } from '../../../../public/Images';

import Image from 'next/image';
import Modal from '@/components/shared/modal.component';

interface ISelectForm {
    label: string;
    selectPlaceholder: string;
    searchPlaceholder: string;
    formData: ILocationDropDown[];
    step: 'region';
    formFunction: (key: 'region', clickedItem: IRegion_SELL) => void;
    translateX: string;
    disabled: boolean;
    disclaimerText: string;
    value: string;
    intialValue: ISmallArea;
    region: IRegion_SELL;
}

const SelectLocationForm = ({
    label,
    selectPlaceholder,
    searchPlaceholder,
    formData,
    formFunction,
    step,
    translateX,
    disabled,
    disclaimerText,
    value,
    intialValue,
    region,
}: ISelectForm) => {
    const { IS_RTL } = useTranslation();
    const [focused, setFocused] = useState(false);
    const [openMap, setOpenMap] = useState(false);
    const { getShowNewMap } = useSellCarNew();
    const showNewMap = getShowNewMap();
    //   const [scrollPosition, setScrollPosition] = useState(0);
    const inputRef = useRef(null);

    //   const handleScroll = () => {
    //     const position = window.pageYOffset;
    //     setScrollPosition(position);
    //   };
    useEffect(() => {
        //Assign click handler to listen the click to close the dropdown when clicked outside
        document.addEventListener('click', handleClickOutside);
        // window.addEventListener('scroll', handleScroll);

        return () => {
            //Remove the listener
            document.removeEventListener('click', handleClickOutside);
            //   window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickOutside = (event: any) => {
        const path = event.path || (event.composedPath && event.composedPath());

        if (!path.includes(inputRef.current)) {
            setFocused(false);
        }
    };

    const openDropDown = () => {
        // if (scrollPosition < 150) {
        //   window.scroll(0, 300);
        // }
        if (!showNewMap) setFocused(true);
    };
    const formFunctionBridge = (key: 'region', clickedItem: IRegion_SELL) => {
        formFunction(key, clickedItem);
        setFocused(false);
        closeMap();
    };
    const closeMap = () => {
        setOpenMap(false);
    };
    const formFunctionBridgeWithoutClose = (
        key: 'region',
        clickedItem: IRegion_SELL
    ) => {
        formFunction(key, clickedItem);
    };
    const { t } = useTranslation();
    return (
        <div ref={inputRef}>
            <div className={styles.select_input_group}>
                <Typography color={'#344054'} variant="caption">
                    {label}
                </Typography>
                <input
                    className={styles.input}
                    value={value}
                    readOnly
                    onFocus={() => openDropDown()}
                    placeholder={selectPlaceholder}
                    disabled={disabled}
                    onClick={() => setOpenMap(true)}
                    style={{
                        paddingTop: IS_RTL ? '9px' : '0px',
                    }}
                />
            </div>
            {showNewMap ? (
                <Modal
                    sx={{ zIndex: 5500000 }}
                    open={openMap}
                    setOpen={closeMap}
                >
                    <div
                        style={{
                            width: '50vw',
                            padding: '24px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                            height: '85vh',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant="subtitle1">
                                {t('selectInspectionLocation')}
                            </Typography>
                            <Image
                                src={X.src}
                                width={X.width}
                                height={X.height}
                                onClick={() => closeMap()}
                                style={{ cursor: 'pointer' }}
                                alt="close"
                            />
                        </div>
                        <LocationMapForm
                            region={region}
                            formFunction={formFunctionBridge}
                            formContent={formData}
                            step={step}
                            open={openMap}
                            disclaimerText={disclaimerText}
                            searchPlaceholder={t('search')}
                            intialValue={intialValue}
                        />
                    </div>
                </Modal>
            ) : (
                // </div>
                <div
                    className={`${styles.select_container} ${
                        focused ? styles.open : ''
                    }`}
                    extra-height="extra-height"
                    style={{ transform: `translateX(${translateX})` }}
                >
                    <LocationFormContent
                        region={region}
                        searchPlaceholder={searchPlaceholder}
                        open={focused}
                        formFunction={formFunctionBridgeWithoutClose}
                        formContent={formData}
                        step={step}
                        disclaimerText={disclaimerText}
                        intialValue={intialValue}
                    />
                </div>
            )}
        </div>
    );
};
export default SelectLocationForm;
